import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async';
import IndexSectionContacts9 from '../components/contacts/IndexSectionContacts9.js';
import Headers from '../components/headers/Header.jsx';
import Hero from '../components/headers/Hero.jsx'

import UtsavFooter from '../components/footers/UtsavFooter.jsx';

const meta = {
    title: '',
    meta: [],
    link: [],
    style: [],
    script: [],
  };
  
  export default function Donate() {
    return (
      <React.Fragment>
         <HelmetProvider>
          <Helmet {...meta}></Helmet>
        </HelmetProvider> 
        <Headers />
        <Hero />
        <IndexSectionContacts9 />
        <UtsavFooter />
      </React.Fragment>
    );
  }

